import {useScoutingReports, reportError} from "@/utils/scoutingReportData";
import ScoutingReportsStatus from "@/components/ScoutingReportsStatus";
import {useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";

import Page from "@/components/Page";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFModal from "@/components/Modal";
import ScoutReportDetail from "@/components/ScoutReportDetail";
import {SUCCESSFUL_OPERATION} from "@/utils/constants";
import {
	deleteReport,
	playerReports,
	reportPlayerName,
} from "@/utils/scoutingReports";

import "../index.scss";

export default function RelazionePage({handleNotification}) {
	const navigate = useNavigate();
	const {id} = useParams();
	const [openConfirm, setOpenConfirm] = useState(false);
	const data = useScoutingReports({reportId: id});
	const {report} = data;
	const others = report
		? playerReports(report.playerId).filter((r) => r.id !== id && r.seasonId === report.seasonId)
		: [];

	const remove = async () => {
		try {
			await deleteReport(id, report.version);
			handleNotification(SUCCESSFUL_OPERATION, "success");
			navigate("/scouting/players/" + report.playerId, {replace: true});
		} catch (error) {
			handleNotification(reportError(error), "error");
		}
	};

	const actions = report
		? [
				{
					icon: <ArrowBackIcon />,
					title: "Indietro",
					color: "info",
					onClick: () => navigate(-1),
				},
				{
					icon: <PersonIcon />,
					title: "Scheda giocatore",
					onClick: () => navigate("/scouting/players/" + report.playerId),
				},
				{
					icon: <EditIcon />,
					title: "Modifica",
					disabled: !report.canEdit || !data.canWrite,
					onClick: () => navigate("/scouting/relazioni/" + id + "/edit"),
				},
				{
					icon: <DeleteIcon />,
					title: "Elimina",
					disabled: !report.canEdit || !data.canWrite,
					color: "error",
					onClick: () => setOpenConfirm(true),
				},
			]
		: [];

	return (
		<Page className="page-container relazioni-page">
			<ScoutingReportsStatus data={data} />
			<Breadcrumbs
				elements={[
					{label: "Relazioni", path: "/scouting/relazioni"},
					{label: "/"},
				]}
				current={report ? reportPlayerName(report.player) : ""}
				actions={<MainActions actions={actions} />}
			/>
			{report ? (
				<ScoutReportDetail
					report={report}
					otherReports={others}
					onOpenReport={(r) => navigate("/scouting/relazioni/" + r.id)}
				/>
			) : (
				<div className="relazioni-empty">
					<strong>
						{data.detailLoading
							? "Caricamento relazione…"
							: data.detailError?.response?.status === 404
								? "Relazione non trovata"
								: data.detailError
									? "Relazione non disponibile. Riprova aprendo di nuovo il dettaglio."
									: "Relazione non disponibile"}
					</strong>
				</div>
			)}
			<VLFModal
				open={openConfirm}
				title="Eliminazione"
				content={<div className="mt-2">Eliminare questa relazione?</div>}
				confirm={remove}
				close={() => setOpenConfirm(false)}
				confirmLabel="Elimina"
			/>
		</Page>
	);
}
